import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import get from "lodash/get";

import {
  maleLargePrimaryNavigationItems,
  femaleLargePrimaryNavigationItems,
  setNavActiveItem,
  getNavActiveItem,
  clearNavActiveItem
} from "@template/state/modules/navigation";
import { MALE, FEMALE } from "@template/state/modules/layout";

import LargePrimaryNavigation from "./LargePrimaryNavigation";

import { getFeaturesLoaded } from "@template/state/modules/features";

const mvtMoveOutletToEndNavigation = items => {
  const resultItems = [...items];
  const outletIndex = resultItems.findIndex(item => item.label === "Outlet");

  if (outletIndex !== -1) {
    const outletElement = resultItems.splice(outletIndex, 1);
    return [...resultItems, ...outletElement];
  }
  return resultItems;
};

const getOutletToEndNavigation = state =>
  get(state, `features["emf-61-web-stc-nav-outlet-end"].enable`);

const itemsSelector = (forGender, state) => {
  const outletToEndNavigation = getOutletToEndNavigation(state);

  switch (forGender) {
    case MALE:
      if (outletToEndNavigation) {
        return mvtMoveOutletToEndNavigation(
          maleLargePrimaryNavigationItems(state)
        );
      }
      return maleLargePrimaryNavigationItems(state);

    case FEMALE:
      if (outletToEndNavigation) {
        return mvtMoveOutletToEndNavigation(
          femaleLargePrimaryNavigationItems(state)
        );
      }
      return femaleLargePrimaryNavigationItems(state);

    default:
      return [];
  }
};

const mapStateToProps = (state, { forGender }) => ({
  currentGender: state.layout.gender,
  items: itemsSelector(forGender, state),
  largeNavActiveItemId: getNavActiveItem(state),
  outletEndNavigation: getOutletToEndNavigation(state),
  featuresLoaded: getFeaturesLoaded(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setNavActiveItem, clearNavActiveItem }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LargePrimaryNavigation);
